import { useCallback, useEffect, useState } from 'react';
import { arrayMove } from '@dnd-kit/sortable';

export default function useDragReorder(rows, onOrderChange) {
    const [localRows, setLocalRows] = useState(rows || []);

    useEffect(() => {
        setLocalRows(rows || []);
    }, [rows]);

    const handleDragEnd = useCallback(
        (event) => {
            const { active, over } = event;
            if (!over || active.id === over.id) return;
            setLocalRows((items) => {
                const oldIndex = items.findIndex((r) => r.id === active.id);
                const newIndex = items.findIndex((r) => r.id === over.id);
                if (oldIndex === -1 || newIndex === -1) return items;
                const reordered = arrayMove(items, oldIndex, newIndex);
                onOrderChange(reordered.map((r, i) => ({ id: r.id, priority: i })));
                return reordered;
            });
        },
        [onOrderChange],
    );

    return { localRows, handleDragEnd };
}
